import IntensityAccordionTable from './IntensityAccordionTable';

export default IntensityAccordionTable;